import { Badge } from "@/components/ui/badge";
import { IdCard, Shield, UserCog } from "lucide-react";
import { UserType } from "@/types/unified-user";

interface UserTypeBadgeProps {
  type: UserType;
  showIcon?: boolean;
}

export function UserTypeBadge({ type, showIcon = true }: UserTypeBadgeProps) {
  const config = {
    directory: {
      label: "Directory",
      icon: IdCard,
      variant: "secondary" as const,
      className: "bg-info/10 text-info dark:bg-info dark:text-info",
    },
    console: {
      label: "Console",
      icon: Shield,
      variant: "secondary" as const,
      className: "bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300",
    },
    both: {
      label: "Both",
      icon: UserCog,
      variant: "secondary" as const,
      className: "bg-success/10 text-success dark:bg-success dark:text-success",
    },
  };

  const { label, icon: Icon, variant, className } = config[type];

  return (
    <Badge variant={variant} className={className}>
      {showIcon && <Icon className="w-3 h-3 mr-1" />}
      {label}
    </Badge>
  );
}
